import { Source } from '../interfaces/Organization';


export class MSource{
    public id: number;
    public name: string;
    public type: number;
    public active: boolean;

    constructor(src: Source, active = true){
        this.id = src.id;
        this.name = src.nombre;
        this.type = src.tipo
        this.active = active;
    }
}
